import React from 'react'

import { Button, Form, Input, Picker, Row, SelectForm } from 'components'
import { MagnifyingGlassIcon } from 'components/Icons'
import { SPACING } from 'utils'

import { ISearchParamsDocumento } from '../../SearchDocumentation'

interface IFilterTableRegister {
  control: any
  errors: any
  empresas: { nmEmpresa: string; idEmpresa: number }[]
  centros: { nmCentro: string; idCentro: number }[]
  // handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  handleSubmit: any
  handleCleanFields: () => void
  handleSearch: (_form?: ISearchParamsDocumento) => void
  // handleOnDateChange: (date: Date) => void
  // handleChangeEmpresa: (idEmpresa: number) => void
  // handleChangeCentro: (idCentro: number) => void
}

const maskFull = () => {
  const item = '#'
  const items = new Array(100).fill(item).join('')
  return items
}

const FilterTableRegister: React.FC<IFilterTableRegister> = ({
  control,
  errors,
  empresas,
  centros,
  handleSubmit,
  // handleChange,
  handleCleanFields,
  handleSearch
  // handleOnDateChange,
  // handleChangeEmpresa,
  // handleChangeCentro
}) => {
  function handleSubmitForm(form: ISearchParamsDocumento) {
    handleSearch(form)
  }

  return (
    <Form onSubmit={handleSubmit(handleSubmitForm)}>
      <Row alignItems="center" justifyContent="start">
        <Input
          label="Contrato"
          formValue="contrato"
          control={control}
          // onChange={handleChange}
          marginRight={SPACING.spacing15}
          maxLength={100}
        />
        <SelectForm
          label="Empresa"
          listOptions={empresas}
          errors={errors}
          placeholder={'Selecione'}
          width="316px"
          formValue="idEmpresa"
          valueMenu="idEmpresa"
          labelMenu="nmEmpresa"
          control={control}
          // onChange={(event) => handleChangeEmpresa(Number(event.target.value))}
          marginRight={SPACING.spacing15}
        />
        <SelectForm
          label="Centro"
          listOptions={centros}
          errors={errors}
          placeholder={'Selecione'}
          width="316px"
          formValue="idCentro"
          valueMenu="idCentro"
          labelMenu="nmCentro"
          control={control}
          // onChange={(event) => handleChangeCentro(Number(event.target.value))}
          marginRight={SPACING.spacing15}
        />
        <Input
          label="CPF/CNPJ/Cód.Fornecedor"
          // onChange={handleChange}
          control={control}
          errors={errors}
          // value={fields.cnpj}
          formValue="cnpj"
          mask={['###.###.###-##', '##.###.###/####-##']}
          marginRight={SPACING.spacing15}
        />
        <Input
          label="Fornecedor"
          // value={fields.fornecedor}
          control={control}
          formValue="fornecedor"
          // onChange={handleChange}
          width="316px"
          maxLength={100}
        />
      </Row>
      <Row alignItems="center" marginTop={SPACING.spacing20}>
        <Picker
          label="Competência"
          // value={fields.competencia}
          formValue="competencia"
          control={control}
          // onChange={(date) => handleOnDateChange(date)}
          marginRight={SPACING.spacing15}
          type="monthAndYear"
        />
        <Input
          label="Caixa Externo"
          // value={fields.caixaExterno}
          control={control}
          formValue="caixaExterno"
          mask={[`${maskFull()}`]}
          // onChange={handleChange}
          marginRight={SPACING.spacing15}
          maxLength={100}
        />
        <Input
          label="Caixa Departamental"
          mask={[`${maskFull()}`]}
          control={control}
          // value={fields.caixaDepartamental}
          // onChange={handleChange}
          formValue="caixaDepartamental"
          maxLength={100}
        />
      </Row>
      <Row
        alignItems="center"
        justifyContent="flex-end"
        marginTop={SPACING.spacing15}
      >
        <Button
          text="Limpar"
          variantButton="text"
          onClick={handleCleanFields}
          marginLeft={SPACING.spacing15}
          marginRight={SPACING.spacing15}
        />
        <Button
          text="Pesquisar"
          endIcon={<MagnifyingGlassIcon />}
          type={'submit'}
          marginLeft={SPACING.spacing15}
          marginRight={SPACING.spacing15}
        />
      </Row>
    </Form>
  )
}

export default FilterTableRegister
